import NewsTipCommentSimpleView from './NewsTipCommentSimpleView'

export default NewsTipCommentSimpleView
